module.exports = __webpack_public_path__ + "static/media/scanned.faa1be00.mp3";